<script>
	export let tabs = []; // 탭 목록
	export let activeTab = ""; // 현재 활성화된 탭
	export let onTabChange; // 탭 변경 시 호출되는 함수

	const handleTabClick = (tab) => {
		activeTab = tab; // 활성화된 탭 변경
		onTabChange(tab); // 부모 컴포넌트에 탭 변경 알림
	};
</script>

<ul class="nav nav-tabs d-flex" role="tablist">
	{#each tabs as { key, text }}
		<li class="nav-item">
			<button
				class="nav-link {activeTab === key ? 'active border-top border-start border-end border-secondary' : ''}"
				style="cursor: pointer;"
				on:click={() => handleTabClick(key)}
			>
				{text}
			</button>
		</li>
	{/each}
</ul>

<style>
	.nav-link {
		border: none; /* 기본 테두리 제거 */
	}
	.nav-link.active {
		border: 1px solid #007bff; /* 선택된 탭에 대한 테두리 스타일 */
	}
</style>
